import { render, staticRenderFns } from "./DeviceManufacturedHistoryView.vue?vue&type=template&id=011bf6e8"
import script from "./DeviceManufacturedHistoryView.vue?vue&type=script&lang=js"
export * from "./DeviceManufacturedHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports